declare var requestIdleCallback: (fn: () => void) => void;

namespace Pages {

    export class SignIn extends Page implements IPage {
        private readonly _deviceFingerprint: HTMLInputElement;
        private readonly _deviceFingerprintSvc: DeviceFingerprintService;

        constructor(el: Element) {
            super(el);

            this._deviceFingerprint = el.querySelector("#DeviceFingerprint");
            if (!this._deviceFingerprint) {
                throw new Error('DeviceFingerprint input not found.');
            }

            this._deviceFingerprintSvc = new DeviceFingerprintService();
        }

        initialize(): void {

            if (!this._deviceFingerprint.value) {
                this._deviceFingerprintSvc.onDeviceFingerprintUpdate = (devicefingerprint) => {
                    this._deviceFingerprint.value = devicefingerprint;
                }

                this._deviceFingerprintSvc.initialize();
            }
        }
    }
}